import { Partner } from "@types-runway/state";

import { admin } from "../../../api";

const useGetPartner = () => {
  const getPartnerDetails = async (partnerId: string): Promise<Partner | null> => {
    try {
      const { data } = await admin.partnerGet(`/${partnerId}`);
      return data;
    } catch {
      return null;
    }
  };

  return { getPartnerDetails };
};

export default useGetPartner;
